
import './App.scss';

import Navigation from './components/Navigation';
import Home from './components/Home';

function App() {
  return (
    <div className="App">
      
      <Navigation />
      <Home />

    </div>
  );
}

export default App;
